// Category visual identity — used for comment borders, tags, etc.
export const CATEGORY_STYLES = {
  affirmations: {
    label: 'Affirmations',
    border: 'border-l-amber-400',
    bg: 'bg-amber-50',
    text: 'text-amber-700',
    dot: 'bg-amber-400',
  },
  'guided-meditations': {
    label: 'Guided Meditations',
    border: 'border-l-indigo-400',
    bg: 'bg-indigo-50',
    text: 'text-indigo-700',
    dot: 'bg-indigo-400',
  },
  sleep: {
    label: 'Sleep',
    border: 'border-l-blue-400',
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    dot: 'bg-blue-400',
  },
  anxiety: {
    label: 'Anxiety',
    border: 'border-l-emerald-400',
    bg: 'bg-emerald-50',
    text: 'text-emerald-700',
    dot: 'bg-emerald-400',
  },
};

export const getCategoryStyle = (categoryId) =>
  CATEGORY_STYLES[categoryId] || {
    label: 'Reflection',
    border: 'border-l-stone-300',
    bg: 'bg-stone-50',
    text: 'text-stone-700',
    dot: 'bg-stone-400',
  };
